"use strict";

var HtmlParser = '__RMD_HTML_PARSER__';
exports.HtmlParser = typeof Symbol === 'undefined' ? HtmlParser : Symbol(HtmlParser);


//////////////////
// WEBPACK FOOTER
// ./~/react-markdown/lib/symbols.js
// module id = 483
// module chunks = 168707334958949